import { UndoRedoManager } from '@/utilityModels/undoRedoManager';

import * as def from '@/definitions'
import { ArrayHelper } from '@/helper/arrayHelper';
import { FrameInfo } from '@/data/productCategory/product/paper/frameInfo/frameInfo';
import { Shape } from './shape/shape';

/** フレーム デザインを置く場所 */

export class Frame
{
    // 左側のマージン
    private _leftMargin : number = 0;
    public get leftMargin() { return this._leftMargin; }
    public set leftMargin(leftMargin) { this._leftMargin = leftMargin; }
    
    // 上側のマージン
    private _topMargin : number = 0;
    public get topMargin() { return this._topMargin; }
    public set topMargin(topMargin) { this._topMargin = topMargin; }

    // 水平のパディング
    private _horizontalPadding : number = 0;
    public get horizontalPadding() { return this._horizontalPadding; }
    public set horizontalPadding(horizontalPadding) { this._horizontalPadding = horizontalPadding; }

    // 垂直のパディング
    private _verticalPadding : number = 0;
    public get verticalPadding() { return this._verticalPadding; }
    public set verticalPadding(verticalPadding) { this._verticalPadding = verticalPadding; }

    // フレーム幅
    private _width : number = 0;
    public get width() { return this._width; }
    public set width(width) { this._width = width; }

    // フレーム高さ
    private _height : number = 0;
    public get height() { return this._height; }
    public set height(height) { this._height = height; }

    // 行
    private _row : number = 0;
    public get row() { return this._row; }
    public set row(row) { this._row = row; }

    // 列
    private _col : number = 0;
    public get col() { return this._col; }
    public set col(col) { this._col = col; }

    // 形状
    private _shape : Shape = new Shape();
    public get shape() { return this._shape; }
    public set shape(shape) { this._shape = shape; }

    // フレーム情報を元にしてフレームを作成する。
    public static createFromFrameInfo(frameInfo : FrameInfo)
    {
        // 新規フレーム作成
        var frame = new Frame();

        frame.leftMargin = frameInfo.leftMargin;
        frame.topMargin = frameInfo.topMargin;
        frame.horizontalPadding = frameInfo.horizontalPadding;
        frame.verticalPadding = frameInfo.verticalPadding;
        frame.width = frameInfo.width;
        frame.height = frameInfo.height;
        frame.col = frameInfo.col;
        frame.row = frameInfo.row;
        if(frameInfo.shapeInfo != null)
        {
            frame.shape = Shape.createFromShapeIndo(frameInfo.shapeInfo, frame.width, frame.height);
        }

        return frame;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            leftMargin : this.leftMargin,
            topMargin : this.topMargin,
            horizontalPadding : this.horizontalPadding,
            verticalPadding : this.verticalPadding,
            width : this.width,
            height : this.height,
            col : this.col,
            row : this.row,
            shape : this.shape
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var frame = new Frame();
        if(jsonData.leftMargin) { frame.leftMargin = jsonData.leftMargin; }
        if(jsonData.topMargin) { frame.topMargin = jsonData.topMargin; }
        if(jsonData.horizontalPadding) { frame.horizontalPadding = jsonData.horizontalPadding; }
        if(jsonData.verticalPadding) { frame.verticalPadding = jsonData.verticalPadding; }
        if(jsonData.width) { frame.width = jsonData.width; }
        if(jsonData.height) { frame.height = jsonData.height; }
        if(jsonData.col) { frame.col = jsonData.col; }
        if(jsonData.row) { frame.row = jsonData.row; }
        if(jsonData.shape)
        {
            frame.shape = Shape.createFromJsonData(jsonData.shape);
        }
        return frame;
    }
}